// components/LSSF/SewingApplicationsList.jsx
import React from 'react';
import BaseList from './BaseList';

const SewingApplicationsList = () => {
  const columns = [
    { key: 'full_name', label: 'Full Name' },
    { key: 'age', label: 'Age' },
    { key: 'aadhar_number', label: 'Aadhar Number' },
    { key: 'parent_spouse_name', label: 'Parent/Spouse Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
    { key: 'pincode', label: 'Pincode' },
  ];

  return (
    <BaseList
      title="Sewing Machine Applications"
      apiEndpoint="/api/v1/mail/sewing-form"
      columns={columns}
      addButtonLink="/dashboard/lssf/add-sewing-application"
      addButtonText="Add Sewing Application"
    />
  );
};

export default SewingApplicationsList;